import { Injectable } from '@angular/core';
import { TenantBenefitChildDetail } from '../../../shared/models/tenant-benefits/tenant-benefit-child-detail';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class MbpHrBenefitDetailsCreateService {
  private readonly tenantBenefitChildDetailSource = new BehaviorSubject<{
    data: Partial<TenantBenefitChildDetail> | null;
    activeCarTab?: number;
  }>(null);
  public readonly tenantBenefitChildDetail$ = this.tenantBenefitChildDetailSource.asObservable();

  public setTenantBenefitChildDetail(
    data: Partial<TenantBenefitChildDetail>,
    activeCarTab?: number
  ) {
    this.tenantBenefitChildDetailSource.next({ data, activeCarTab });
  }
}
